import useMcdApiMutation from "./useMcdApiMutation";

export interface IRequest {
  INVOICE_NO: string // 送り状番号
  DIST_TARGET_DATE: string // 配達指定日付
  DIST_TARGET_TIMEZONE_CD?: string // 配達指定時間帯コード
  PKG_DROP_FLG: ('0' | '1') // 置配フラグ
  PKG_DROP_CD: string // 置配コード
  CONSIGNEE_NAME: string // 荷受人名称
  CONSIGNEE_POSTCD: string // 荷受人郵便番号
  CONSIGNEE_CITY_CD: string // 荷受人市区町村コード
  CONSIGNEE_ADDR: string // 荷受人町域番地
  CONSIGNEE_BLDG_NAME?: string // 荷受人建物名
  RESULT_NOTICE_MAIL_ADDR?: string // 結果通知メールアドレス
  RESULT_NOTICE_MAIL_ADDR_CONFIRMATION?: string // メールアドレス（確認）
}

interface IResponse {
  SORTING_CD: string
}

/**
 * [POST] RegisterDistDateChangedAccept.json
 * 配達日変更受付を登録する：配達日変更受付画面で入力した情報を登録する
 * */
export const useRegisterDistDateChangedAccept = (params?: IRequest) => {
  const url = '/sinfoniacloud/api/RegisterDistDateChangedAccept.json'
  return useMcdApiMutation<IResponse>(url, params)
}

export default useRegisterDistDateChangedAccept

/*

{
    "uuid": "e477f38d-0134-4dec-adce-14f1a2012bbc",
    "documentation": "[PCS] 配達日変更受付を登録する：配達日変更受付画面で入力した情報を登録する",
    "method": "post",
    "endpoint": "RegisterDistDateChangedAccept.json",
    "responses": [
        {
            "uuid": "fadff438-1e4c-4c85-9306-c476096f4953",
            "body": "{\n  \"isError\": false,\n  \"body\": {}\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": true
        },
        {
            "uuid": "f5eba7ba-4ac1-4c6e-9a30-144548bb435f",
            "body": "{\n  \"errorInfo\": {\n    \"errorCode\": \"E-CGTC-999999\",\n    \"message\": \"E-CGTC-999999:何らかのエラーが発生しました。 - [ 2022/11/08 16:03:56.898 : NIEZ-PaaS-SV1, 10.42.0.30, default task-6 ]\",\n    \"stackTrace\": \"minimalism.ApplicationException: E-CNCRG-100003:部屋が特定できませんでした。部屋番号 : 444 - [ 2022/11/08 16:03:56.898 : NIEZ-PaaS-SV1, 10.42.0.30, default task-6 ]\\n\\tat deployment.sinfoniacloud.ear//sinfoniacloud.lib.qt.api.QtResponseWrapper.errorChecker(QtResponseWrapper.java:70)...\",\n    \"statusCode\": 200\n  },\n  \"isError\": true\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": false
        },
        {
            "uuid": "4b2d62ad-3aa1-489d-b70a-31fdadc4e8f2",
            "body": "",
            "latency": 0,
            "statusCode": 500,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": false
        }
    ],
    "enabled": true,
    "responseMode": null
}

*/
